import { gql } from "@apollo/client";

export const signup = gql`
  mutation signup(
    $email: String!
    $password: String!
    $providerId: String!
    $referralCode: String
  ) {
    signup(
      data: {
        authType: "normal"
        email: $email
        password: $password
        role: "doctor"
        providerId: $providerId
        referralCode: $referralCode
      }
    ) {
      account {
        dociId
        access_token
        refresh_token
        providerId
        _id
        email
      }
      message
    }
  }
`;

export const login = gql`
  mutation login($email: String!, $password: String!) {
    login(data: { authType: "normal", email: $email, password: $password }) {
      account {
        _id
        dociId
        email
        providerId
        isEmailVerified
        isActive
        access_token
        refresh_token
        nextStep
        isPasswordTemporary
        role {
          _id
          name
        }
      }
    }
  }
`;

export const createDoctorProfile = gql`
  mutation createDoctorProfile(
    $firstName: String!
    $lastName: String!
    $gender: String
    $dociId: String!
    $hospital: String!
    $specialization: String!
    $dob: DateTime!
    $cadre: String!
    $providerId: String!
    $phoneNumber: String!
    $image: String!
  ) {
    createDoctorProfile(
      data: {
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
        dociId: $dociId
        hospital: $hospital
        specialization: $specialization
        dob: $dob
        gender: $gender
        cadre: $cadre
        image: $image
        providerId: $providerId
      }
    ) {
      profile {
        _id
        dociId
        createdAt
        updatedAt
        firstName
        lastName
        gender
        phoneNumber
        email
        hospital
        specialization
        dob
        cadre
        picture
        providerId {
          _id
        }
      }
    }
  }
`;

export const updateDoctorProfile = gql`
  mutation updateDoctorProfile(
    $id: String!
    $firstName: String!
    $lastName: String!
    $gender: String!
    $phoneNumber: String!
    $hospital: String!
    $specialization: String!
    $dob: String!
    $cadre: String!
    $image: String!
  ) {
    updateDoctorProfile(
      data: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
        hospital: $hospital
        specialization: $specialization
        dob: $dob
        gender: $gender
        cadre: $cadre
        image: $image
      }
    ) {
      profile {
        _id
        dociId
        createdAt
        updatedAt
        firstName
        lastName
        gender
        phoneNumber
        email
        hospital
        specialization
        dob
        cadre
        picture
        providerId {
          _id
        }
      }
    }
  }
`;

export const createDoctorVerification = gql`
  mutation createVerification(
    $expiryDate: DateTime!
    $licenseImage: String!
    $degree: String!
    $graduation: String!
    $year: DateTime!
    $image: String!
    $number: String!
    $type: String!
    $graduationImage: String!
    $facebook: String!
    $instagram: String!
    $reference: String!
    $doctorName: String!
    $doctorInstitution: String!
    $doctorPosition: String!
    $doctorEmail: String!
    $profileId: String!
  ) {
    createVerification(
      data: {
        qualification: { degree: $degree, year: $year, image: $image }
        license: {
          number: $number
          type: $type
          expiry_date: $expiryDate
          image: $licenseImage
        }
        yearbook: { graduation_year: $graduation, image: $graduationImage }
        alumni_association: {
          facebook_group_name: $facebook
          instagram_handle: $instagram
        }
        reference: { reference_code: $reference }
        external_reference: {
          doctor_name: $doctorName
          doctor_institution: $doctorInstitution
          doctor_position: $doctorPosition
          doctor_email: $doctorEmail
        }
        profileId: $profileId
      }
    ) {
      message
      data {
        _id
        qualification
        license
        yearbook
        alumni_association
        reference
        external_reference
        status
        createdAt
        updatedAt
        profileId
      }
    }
  }
`;

export const resetPassword = gql`
  mutation resetPassword($email: String!) {
    resetPassword(data: { email: $email })
  }
`;

export const completePasswordReset = gql`
  mutation completePasswordReset(
    $email: String!
    $newPassword: String!
    $otp: String!
  ) {
    completePasswordReset(
      data: { email: $email, password: $newPassword, otp: $otp }
    ) {
      account {
        _id
        email
        dociId
        createdAt
        updatedAt
        isEmailVerified
        isPasswordTemporary
      }
    }
  }
`;

export const createLogout = gql`
  mutation logout {
    logout
  }
`;
